/* Card Finder quiz – Equal Eats. Vanilla JS, no dependencies. */
(function () {
  'use strict';
  var PLACEHOLDER = /^\s*[\(\*]?\s*(select|please|pease)/i;

  function CardFinder(root) {
    this.root = root;
    this.cfg = JSON.parse(root.querySelector('[data-cf-config]').textContent);
    this.results = JSON.parse(root.querySelector('[data-cf-results]').textContent);
    this.screen = root.querySelector('[data-cf-screen]');
    this.backBtn = root.querySelector('[data-cf-back]');
    this.dotsEl = root.querySelector('[data-cf-dots]');
    this.form = root.querySelector('[data-cf-form]');
    this.hist = [];
    this.sel = [];
    this.showMore = {};
    this.started = false;
    this.cache = {};
    var self = this;
    this.backBtn.addEventListener('click', function () { self.back(); });
    this.go(this.cfg.start || 'q1');
  }

  CardFinder.prototype.emit = function (name, data) {
    data = data || {};
    try { document.dispatchEvent(new CustomEvent('cardfinder:' + name, { detail: data })); } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('card_finder_' + name, data);
      }
    } catch (e) {}
  };

  CardFinder.prototype.esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  CardFinder.prototype.dots = function (step, done) {
    var total = this.cfg.steps || 3, h = '';
    for (var i = 0; i < total; i++) {
      var cls = done || i < step - 1 ? ' is-done' : (i === step - 1 ? ' is-on' : '');
      h += '<span class="cf__dot' + cls + '"></span>';
    }
    this.dotsEl.innerHTML = h;
  };

  CardFinder.prototype.go = function (target, noPush) {
    if (!noPush) this.hist.push(target);
    this.backBtn.classList.toggle('is-visible', this.hist.length > 1);
    if (target.indexOf('r:') === 0) this.showResult(target.slice(2));
    else this.showQuestion(target);
    if (noPush !== 'init' && this.hist.length > 1) {
      var top = this.root.getBoundingClientRect().top;
      if (top < 0) this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  CardFinder.prototype.back = function () {
    if (this.hist.length < 2) return;
    this.hist.pop();
    this.go(this.hist[this.hist.length - 1], true);
  };

  CardFinder.prototype.showQuestion = function (id) {
    var q = this.cfg.questions[id], self = this;
    if (!q) return this.go('r:' + (this.cfg.fallback || 'custom_allergy'), true);
    if (!q.multi) this.sel = [];
    this.dots(q.step || 1, false);
    var opts = q.options.map(function (o, i) { return { o: o, i: i }; });
    var hidden = opts.filter(function (x) { return x.o.more; });
    var visible = this.showMore[id] ? opts : opts.filter(function (x) { return !x.o.more; });
    var h = '<div class="cf__head"><span class="cf__kicker">' + this.esc(q.kicker) + '</span>' +
      '<h2 class="cf__title">' + this.esc(q.title) + '</h2>' +
      '<p class="cf__sub">' + (q.sub ? this.esc(q.sub) : '&nbsp;') + '</p></div>' +
      '<div class="cf__grid" role="' + (q.multi ? 'group' : 'radiogroup') + '" aria-label="' + this.esc(q.title) + '">';
    visible.forEach(function (x) {
      var on = q.multi && self.sel.indexOf(x.o.value) > -1;
      h += '<button type="button" class="cf__tile' + (on ? ' is-selected' : '') + '" data-i="' + x.i + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
        '<span class="cf__emoji" aria-hidden="true">' + self.esc(x.o.emoji) + '</span>' +
        '<span class="cf__label">' + self.esc(x.o.label) + '</span>' +
        (x.o.hint ? '<span class="cf__hint">' + self.esc(x.o.hint) + '</span>' : '') + '</button>';
    });
    if (hidden.length && !this.showMore[id]) {
      h += '<button type="button" class="cf__tile cf__tile--more" data-more="1"><span class="cf__emoji" aria-hidden="true">➕</span><span class="cf__label">' + this.esc(this.cfg.showMoreLabel || 'Show more') + '</span></button>';
    }
    h += '</div>';
    if (q.multi) {
      h += '<div class="cf__ctabar"><button type="button" class="cf__btn" data-next' + (this.sel.length ? '' : ' disabled') + '>' +
        this.esc(q.cta || 'Show my card →') + ' <span class="cf__count">' + this.sel.length + '</span></button></div>';
    }
    this.screen.innerHTML = h;
    this.screen.querySelectorAll('.cf__tile').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.dataset.more) { self.showMore[id] = true; return self.showQuestion(id); }
        var o = q.options[+b.dataset.i];
        if (!self.started) { self.started = true; self.emit('started', { first_answer: o.label }); }
        if (q.multi) {
          var k = self.sel.indexOf(o.value);
          if (k > -1) self.sel.splice(k, 1); else self.sel.push(o.value);
          self.showQuestion(id);
        } else {
          self.go(o.next);
        }
      });
    });
    var nx = this.screen.querySelector('[data-next]');
    if (nx) nx.addEventListener('click', function () { self.go(self.resolve(q)); });
  };

  CardFinder.prototype.resolve = function (q) {
    var s = this.sel.slice(), r = q.resolve || {};
    var fb = r.fallback || ('r:' + (this.cfg.fallback || 'custom_allergy'));
    var has = function (v) { return s.indexOf(v) > -1; };
    var combos = r.combos || [];
    for (var i = 0; i < combos.length; i++) {
      var c = combos[i].values;
      if (c.length === s.length && c.every(has)) return combos[i].next;
    }
    var contains = r.contains || [];
    for (var j = 0; j < contains.length; j++) {
      if (s.length > contains[j].values.length && contains[j].values.every(has)) return contains[j].next;
    }
    if ((r.exclusive || []).some(has)) return fb;
    if (s.length === 1) {
      var o = q.options.filter(function (x) { return x.value === s[0]; })[0];
      return o && o.next ? o.next : fb;
    }
    return fb;
  };

  CardFinder.prototype.fetchProduct = function (handle) {
    if (this.cache[handle]) return this.cache[handle];
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    this.cache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .catch(function () { return null; });
    return this.cache[handle];
  };

  CardFinder.prototype.money = function (cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
  };

  CardFinder.prototype.showResult = function (key) {
    var r = this.results[key], self = this;
    if (!r) r = this.results[this.cfg.fallback || 'custom_allergy'];
    this.current = r;
    this.dots(this.cfg.steps || 3, true);
    this.emit('completed', { result: r.label, result_key: r.key, answers: this.sel.slice() });
    var h = '<div class="cf__head"><div class="cf__badge" aria-hidden="true">' + this.esc(r.emoji) + '</div>' +
      '<span class="cf__kicker">' + this.esc(this.cfg.resultKicker || 'Your perfect match') + '</span>' +
      '<h2 class="cf__title">' + this.esc(r.label) + '</h2>' +
      '<p class="cf__sub">' + this.esc(r.blurb || this.cfg.resultBlurb || '') + '</p></div>' +
      '<div class="cf__cards" data-cf-cards>' + r.products.map(function (p) { return self.cardSkeleton(p, false); }).join('') + '</div>';
    if (r.extras && r.extras.length) {
      h += '<h3 class="cf__extras-title">' + this.esc(this.cfg.extrasTitle || 'Also handy') + '</h3>' +
        '<div class="cf__cards cf__cards--extras" data-cf-extras>' + r.extras.map(function (p) { return self.cardSkeleton(p, true); }).join('') + '</div>';
    }
    h += '<p class="cf__foot">' + this.esc(this.cfg.restartPrompt || 'Not quite right?') + ' <button type="button" class="cf__link" data-restart>' +
      this.esc(this.cfg.restartLabel || 'Start over') + '</button>' +
      (this.cfg.browseUrl ? ' · <a class="cf__link" href="' + this.esc(this.cfg.browseUrl) + '">' + this.esc(this.cfg.browseLabel || 'Browse all cards') + '</a>' : '') + '</p>';
    this.screen.innerHTML = h;
    this.screen.querySelector('[data-restart]').addEventListener('click', function () {
      self.hist = []; self.sel = []; self.showMore = {}; self.go(self.cfg.start || 'q1');
    });
    this.screen.querySelectorAll('[data-cf-card]').forEach(function (el) { self.hydrate(el, r); });
    this.screen.querySelectorAll('[data-cf-card] .cf__img, [data-cf-card] .cf__card-title a').forEach(function (a) {
      a.addEventListener('click', function () {
        self.setAttributes(r, { keepalive: true });
        self.emit('product_click', { result: r.label, product: a.closest('[data-cf-card]').dataset.handle });
      });
    });
  };

  CardFinder.prototype.cardSkeleton = function (p, extra) {
    return '<div class="cf__card' + (extra ? ' cf__card--extra' : '') + '" data-cf-card data-handle="' + this.esc(p.handle) + '" data-personalise="' + (p.personalise ? '1' : '') + '">' +
      '<a class="cf__img" href="' + this.esc(p.url) + '">' + (p.image ? '<img src="' + this.esc(p.image) + '" alt="' + this.esc(p.title) + '" loading="lazy" width="600" height="450">' : '') + '</a>' +
      '<span class="cf__tag' + (p.digital ? ' cf__tag--digital' : '') + '">' + this.esc(p.digital ? (this.cfg.tagDigital || '📄 Instant PDF download') : (p.tag || (p.idcard ? (this.cfg.tagId || '🪪 Emergency ID card') : (this.cfg.tagPhysical || '💳 Durable plastic card')))) + '</span>' +
      '<h3 class="cf__card-title"><a href="' + this.esc(p.url) + '">' + this.esc(p.title) + '</a></h3>' +
      '<div class="cf__price" data-price>' + this.esc(typeof p.cents === 'number' ? this.money(p.cents) : p.price) + '</div>' +
      '<div class="cf__buy" data-buy><span class="cf__loading">…</span></div>' +
      '<p class="cf__msg" data-msg role="status" aria-live="polite"></p></div>';
  };

  CardFinder.prototype.hydrate = function (el, r) {
    var self = this, handle = el.dataset.handle, buy = el.querySelector('[data-buy]');
    var info = r.products.concat(r.extras || []).filter(function (x) { return x.handle === handle; })[0] || {};
    if (el.dataset.personalise) {
      buy.innerHTML = '<a class="cf__btn cf__btn--aqua cf__btn--full" href="' + this.esc(info.url) + '" data-go>' + this.esc(this.cfg.personaliseLabel || 'Personalise my card →') + '</a>';
      buy.querySelector('[data-go]').addEventListener('click', function (e) {
        e.preventDefault();
        var href = this.href;
        self.setAttributes(r).then(function () {
          self.emit('personalise_click', { result: r.label, product: handle });
          window.location.href = href;
        });
      });
      return;
    }
    this.fetchProduct(handle).then(function (prod) {
      if (!prod) { buy.innerHTML = '<a class="cf__btn cf__btn--aqua cf__btn--full" href="' + self.esc(info.url) + '">' + self.esc(self.cfg.viewLabel || 'View card →') + '</a>'; return; }
      var vs = prod.variants.filter(function (v) { return !PLACEHOLDER.test(v.title); });
      var avail = vs.filter(function (v) { return v.available; });
      if (!avail.length) { buy.innerHTML = '<span class="cf__soldout">' + self.esc(self.cfg.soldOutLabel || 'Currently unavailable') + '</span>'; return; }
      var min = Math.min.apply(null, avail.map(function (v) { return v.price; }));
      var max = Math.max.apply(null, avail.map(function (v) { return v.price; }));
      el.querySelector('[data-price]').textContent = (min !== max ? (self.cfg.fromLabel || 'From') + ' ' : '') + self.money(min);
      var optName = (prod.options && prod.options[0] && (prod.options[0].name || prod.options[0])) || 'Option';
      if (/order 1 card|title/i.test(optName)) optName = 'Language';
      var single = avail.length === 1 && vs.length === 1;
      var h = '';
      if (!single) {
        h += '<label class="cf__visually-hidden" for="cf-' + handle + '">' + self.esc(optName) + '</label>' +
          '<select class="cf__select" id="cf-' + handle + '" data-variant><option value="">' + self.esc((self.cfg.choosePrefix || 'Choose') + ' ' + optName.toLowerCase() + '…') + '</option>' +
          vs.map(function (v) { return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + self.esc(v.title) + (v.available ? '' : ' – sold out') + '</option>'; }).join('') + '</select>';
      }
      h += '<button type="button" class="cf__btn cf__btn--aqua cf__btn--full" data-add' + (single ? ' data-id="' + avail[0].id + '"' : ' disabled') + '>' + self.esc(self.cfg.addLabel || 'Add to cart') + '</button>';
      buy.innerHTML = h;
      var sel = buy.querySelector('[data-variant]'), btn = buy.querySelector('[data-add]');
      if (sel) sel.addEventListener('change', function () {
        btn.disabled = !sel.value; btn.dataset.id = sel.value;
        var v = vs.filter(function (x) { return String(x.id) === sel.value; })[0];
        if (v) el.querySelector('[data-price]').textContent = self.money(v.price);
      });
      btn.addEventListener('click', function () { self.add(btn, el, r, prod); });
    });
  };

  /* Cart attributes for quiz attribution. Flow tags orders whose customAttributes has quiz=card-finder.
     keepalive lets the request finish even if the page navigates away right after. */
  CardFinder.prototype.setAttributes = function (r, opts) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    try { sessionStorage.setItem('cf_quiz', 'card-finder'); } catch (e) {}
    var attrs = { 'quiz': 'card-finder', 'Source': 'Card Finder Quiz' };
    if (r && r.label) attrs['Quiz result'] = r.label;
    return fetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin', keepalive: !!(opts && opts.keepalive),
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  };

  CardFinder.prototype.add = function (btn, el, r, prod) {
    var self = this, id = btn.dataset.id, msg = el.querySelector('[data-msg]');
    if (!id) { msg.textContent = this.cfg.chooseFirst || 'Please choose a language first.'; return; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    btn.disabled = true; btn.classList.add('is-loading'); msg.textContent = '';
    this.setAttributes(r).then(function () {
      return fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties: { '_quiz': 'Card Finder – ' + r.label } }] })
      });
    }).then(function (res) { return res.json().then(function (j) { if (!res.ok) throw j; return j; }); })
      .then(function (j) {
        var item = (j.items && j.items[0]) || j;
        msg.textContent = self.cfg.addedLabel || 'Added to your cart ✓';
        self.emit('add_to_cart', { result: r.label, product: prod.handle, variant_id: Number(id), price: item.final_price || item.price });
        var input = self.form.querySelector('[name="id"]'); input.value = id;
        var cartType = window.theme && theme.settings && theme.settings.cartType;
        if (cartType === 'page') { window.location.href = root + 'cart'; return; }
        self.form.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: btn }, bubbles: true }));
      })
      .catch(function (e) { msg.textContent = (e && (e.description || e.message)) || 'Sorry, something went wrong. Please try again.'; })
      .then(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
  };

  function init() {
    document.querySelectorAll('[data-card-finder]:not([data-cf-ready])').forEach(function (el) {
      el.setAttribute('data-cf-ready', '');
      try { el.cardFinder = new CardFinder(el); } catch (e) { if (window.console) console.error('Card Finder', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);

  /* "Help me choose" links: smooth-scroll to #card-finder, clearing any fixed/sticky header */
  function headerBottom() {
    var max = 0;
    document.querySelectorAll('header, .site-header, .header-sticky-wrapper, [data-section-type="header"]').forEach(function (h) {
      var cs = getComputedStyle(h), r = h.getBoundingClientRect();
      if ((cs.position === 'fixed' || cs.position === 'sticky') && r.top <= 1 && r.bottom > 0 && cs.visibility !== 'hidden') max = Math.max(max, r.bottom);
    });
    return max;
  }
  function jumpToFinder(anchor) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hdr = document.querySelector('.site-header');
    var guess = Math.max(headerBottom(), (window.matchMedia('(max-width: 768px)').matches && hdr) ? hdr.offsetHeight : 0);
    var y = function (off) { return anchor.getBoundingClientRect().top + window.pageYOffset - off - 12; };
    window.scrollTo({ top: y(guess), behavior: reduce ? 'auto' : 'smooth' });
    var done = false;
    var fix = function () {
      if (done) return; done = true;
      var hb = headerBottom(), top = anchor.getBoundingClientRect().top;
      if (hb && top < hb + 4) window.scrollBy({ top: top - hb - 12, behavior: reduce ? 'auto' : 'smooth' });
    };
    if ('onscrollend' in window) window.addEventListener('scrollend', fix, { once: true });
    setTimeout(fix, 1200);
    if (history.replaceState) history.replaceState(null, '', '#card-finder');
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!/#card-finder$/.test(href)) return;
    var anchor = document.getElementById('card-finder');
    if (!anchor) return; /* not on the homepage: let the link navigate to /#card-finder */
    try { var u = new URL(a.href, location.href); if (u.pathname !== location.pathname) return; } catch (err) {}
    e.preventDefault();
    jumpToFinder(anchor);
  });
})();
